<template>
  <div>
    Post ID: {{ $route.params.id }} sddfd
  </div>
</template>

